// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--pYnE9","container":"container--kZYVI","list":"list--J7FJx","fadeSlideUp":"fadeSlideUp--PFbhm"};